"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suggestion = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var getWixImageUrl_1 = require("./getWixImageUrl");
var Thumbnail_1 = require("../Thumbnail");
var Title_1 = require("../Title");
var Description_1 = require("../Description");
var Suggestion_st_css_1 = require("./Suggestion.st.css");
var THUMBNAIL_WIDTH = 176;
var THUMBNAIL_HEIGHT = 124;
var Suggestion = /** @class */ (function (_super) {
    tslib_1.__extends(Suggestion, _super);
    function Suggestion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Suggestion.prototype.render = function () {
        var _a = this.props, item = _a.item, onClick = _a.onClick, onLinkClick = _a.onLinkClick, renderContent = _a.renderContent, _b = _a.thumbnailHeight, thumbnailHeight = _b === void 0 ? THUMBNAIL_HEIGHT : _b, _c = _a.thumbnailWidth, thumbnailWidth = _c === void 0 ? THUMBNAIL_WIDTH : _c;
        var imageUrl;
        if (item.image &&
            'name' in item.image &&
            item.image.name.startsWith('http')) {
            imageUrl = item.image.name;
        }
        else {
            imageUrl =
                getWixImageUrl_1.getWixImageUrl(item.image, thumbnailWidth, thumbnailHeight) || '';
        }
        return (React.createElement("li", { "data-hook": "list-layout-item", role: "listitem", className: Suggestion_st_css_1.st(Suggestion_st_css_1.classes.root, { mobileView: false }, this.props.className), onClick: onClick },
            React.createElement(Thumbnail_1.Thumbnail, { className: Suggestion_st_css_1.st(Suggestion_st_css_1.classes.thumbnail), title: item.title, onClick: onLinkClick, url: item.url, imageUrl: imageUrl }),
            renderContent ? renderContent(this.props) : null));
    };
    Suggestion.defaultProps = {
        renderContent: function (props) {
            var renderDescription = props.renderDescription, renderTitle = props.renderTitle;
            return (React.createElement("div", { className: Suggestion_st_css_1.st(Suggestion_st_css_1.classes.content) },
                renderTitle ? renderTitle(props) : null,
                renderDescription ? renderDescription(props) : null));
        },
        renderTitle: function (_a) {
            var item = _a.item, onLinkClick = _a.onLinkClick;
            return (React.createElement(Title_1.Title, { className: Suggestion_st_css_1.st(Suggestion_st_css_1.classes.title), title: item.title, onClick: onLinkClick, url: item.url }));
        },
        renderDescription: function (_a) {
            var item = _a.item;
            return (React.createElement(Description_1.Description, { className: Suggestion_st_css_1.st(Suggestion_st_css_1.classes.description), description: item.description }));
        },
    };
    return Suggestion;
}(React.Component));
exports.Suggestion = Suggestion;
//# sourceMappingURL=Suggestion.js.map